<template>
  <div class="flex p-20">
    <div class="flex flex-col w-1/3">
      <div class="text-16 font-bold">Additional Filters</div>
    </div>

    <div class="flex flex-col w-[500px]">
      <draggable :list="descriptionList" item-key="order" @end="reindexDescriptionLabels" class="space-y-8">
        <template #item="{ element }">
          <div class="flex items-center gap-8">
            <div class="text-gray-500 cursor-move">⋮⋮</div>
            <SparkInput
              v-model="element.label"
              type="text"
              class="flex-1"
              custom="h-40"
              name="label"
              maxlength="100"
              @blur="editDescriptionLabel(element.uid, element.label)"
            >
              <template #suffix v-if="element.label === 'Material' || element.label === 'Technology'">
                <SparkButton
                  class="text-primary-500 transition-colors"
                  variant="plain"
                  @click="autoFillDescriptionField(element.label)"
                >
                  <div>Auto-fill</div>
                </SparkButton>
              </template>
            </SparkInput>
            <button
              class="text-gray-500 hover:text-red-500 transition-colors"
              @click="deleteDescriptionLabel(element.uid)"
            >
              <i class="fas fa-trash" />
            </button>
          </div>
        </template>
      </draggable>

      <SparkButton variant="plain" class="text-primary-500 self-start mt-16" @click="showAddFilterModal = true"
        >Add filter</SparkButton
      >
    </div>

    <AddFilterModal :show="showAddFilterModal" @close="showAddFilterModal = false" @add="addNewDescriptionLabel" />
  </div>
</template>

<script>
import draggable from 'vuedraggable';
import SparkInput from '@/components/SparkComponents/SparkInput.vue';
import SparkButton from '@/components/SparkComponents/SparkButton.vue';
import AddFilterModal from '@/views/Settings/views/prp/modals/AddFilterModal.vue';
import { mapState } from 'vuex';

export default {
  name: 'TemplateDescription',

  components: { draggable, SparkInput, SparkButton, AddFilterModal },

  emits: ['changed-description'],

  data() {
    return {
      descriptionLabels: {},
      newFieldLabel: '',
      showAddFilterModal: false,
    };
  },

  computed: {
    ...mapState('application', ['axiosInstance']),

    descriptionList() {
      let descriptions = Object.values(this.descriptionLabels);
      return descriptions.sort((a, b) => a.order - b.order);
    },
  },

  mounted() {
    this.getDescriptionLabels();
  },

  methods: {
    async addNewDescriptionLabel(label) {
      let formData = {
        label,
      };
      await this.axiosInstance.post('/api/v1/description/', formData).then(() => {
        this.getDescriptionLabels();
        this.$emit('changed-description');
      });
    },

    async deleteDescriptionLabel(uid) {
      await this.axiosInstance.delete(`/api/v1/description/${uid}/`).then(() => {
        this.getDescriptionLabels();
        this.$emit('changed-description');
      });
    },

    async editDescriptionLabel(uid, label) {
      let formData = {
        label: label,
      };
      await this.axiosInstance.put(`/api/v1/description/${uid}/`, formData).then(() => {
        this.getDescriptionLabels();
        this.$emit('changed-description');
      });
    },

    async getDescriptionLabels() {
      await this.axiosInstance.get('/api/v1/description-list/').then(response => {
        this.descriptionLabels = response.data;
      });
    },

    async autoFillDescriptionField(field) {
      await this.axiosInstance.post(`/api/v1/prp-fill-description-values/`, { field_to_fill: field }).then(() => {
        this.getDescriptionLabels();
        this.$emit('changed-description');
      });
    },

    reindexDescriptionLabels() {
      let formData = {
        template_order: {},
      };
      this.descriptionList.forEach((description, index) => {
        description.order = index;
        formData.template_order[index] = description.uid;
      });
      this.axiosInstance.put(`api/v1/description-list/`, formData).then(() => {
        this.$emit('changed-description');
      });
    },
  },
};
</script>
